'use es6';

import FilterOperatorMultiStringInput from 'customer-data-filters/components/operator/FilterOperatorMultiStringInput';
import FilterOperatorOwnerInput from 'customer-data-filters/components/operator/FilterOperatorOwnerInput';
export default {
  hs_at_mentioned_owner_ids: {
    InputComponent: FilterOperatorOwnerInput
  },
  hs_attachment_ids: {
    InputComponent: FilterOperatorMultiStringInput
  }
};